/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Temperature_AbridgedInputs */



/**
* | output |
* | --- |
* | "Ext. temp." |
*
* @param {External_Temperature_AbridgedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const external_temperature_abridged = /** @type {((inputs?: External_Temperature_AbridgedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Temperature_AbridgedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ext. temp.")
	return /** @type {LocalizedString} */ ("T°ext")
});